import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ResetPasswordService } from "../services/reset-password.service";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  isLoading = false;
  token: string | null = null;
  isNewPasswordVisible = false;
  isConfirmPasswordVisible = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private resetPasswordService: ResetPasswordService,
    private toast: ToastrService,
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get("token");

    if (!this.token) {
      this.toast.error("Link inválido. Solicite uma nova redefinição de senha.");
      this.router.navigate(["/forgot-password"]);
      return;
    }

    this.resetForm = this.fb.group(
      {
        newPassword: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required]],
      },
      { validators: this.passwordsMatch },
    );
  }

  private passwordsMatch(group: AbstractControl): ValidationErrors | null {
    return group.get("newPassword")?.value === group.get("confirmPassword")?.value ? null : { passwordMismatch: true };
  }

  resetPassword(): void {
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.resetForm.disable();

    const { newPassword, confirmPassword } = this.resetForm.getRawValue();

    this.resetPasswordService.resetPassword({ token: this.token, newPassword, confirmPassword }).subscribe({
      next: () => {
        this.toast.success("🎉 Senha redefinida! Faça login com a nova senha.");
        this.router.navigate(["/sign-in"]);
      },
      error: (error: HttpErrorResponse) => {
        this.toast.error(error.error?.message ?? "Erro ao redefinir a senha.");
        this.isLoading = false;
        this.resetForm.enable();
      },
    });
  }

  toggleNewPasswordVisibility(): void {
    this.isNewPasswordVisible = !this.isNewPasswordVisible;
  }

  toggleConfirmPasswordVisibility(): void {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }
}
